import React, { Component } from 'react';
import cn from 'classnames';

import CTA from 'react-scale/components/tailwind/CTA';
import LidarIframe from 'react-scale/components/website/index/Products/examples/LidarIframe';

import { mq } from 'react-scale/components/website/big/Themes';

interface Scene {
  title: string;
  frames: [];
  annotations: string;
  showImages: boolean;
  frame: number;
}

interface SceneViewerProps {
  sceneActive?: number;
  viewerTheme: {
    hover: string;
    arrow: string;
  };
  commingSoon: boolean;
  scenes: any;
  svgLoaded?: boolean;
  image?: string;
  bgColor: string;
}

interface IState {
  sceneActive: number;
  svgLoaded: boolean;
  scene: {
    title: string;
    frames: [];
    annotations: string;
    showImages: boolean;
    frame: number;
  };
}

class SceneViewer extends Component<SceneViewerProps, IState> {
  private image: React.RefObject<HTMLInputElement>;
  constructor(props: any) {
    super(props);
    this.state = {
      scene: this.props.scenes[0],
      sceneActive: 0,
      svgLoaded: false
    };
    this.image = React.createRef();
  }

  updateScene = (sceneActive: any, scene: any) => {
    this.setState({ sceneActive, scene });
  };

  updateSelect = (ev: any) => {
    const sceneActive = parseInt(ev.target.value);
    this.updateScene(sceneActive, this.props.scenes[sceneActive]);
  };

  static defaultProps = { bgColor: '#000000' };

  render() {
    const { viewerTheme, commingSoon, scenes, bgColor } = this.props;

    return (
      <div>
        <div className="lidar">
          <div className="scenes-overflow">
            <ul>
              {scenes.map((scene: any, i: any) => (
                <li
                  key={scene.title}
                  onClick={() => this.updateScene(i, scenes[i])}
                  className={cn({ active: this.state.sceneActive === i })}
                >
                  <span>{scene.title}</span>
                </li>
              ))}
              {commingSoon && (
                <>
                  <li className="soon">
                    <span>Scene #{scenes.length + 1}</span>
                  </li>
                  <li className="soon">
                    <span>Scene #{scenes.length + 2}</span>
                  </li>
                  <li className="soon">
                    <span>Scene #{scenes.length + 3}</span>
                  </li>
                </>
              )}
            </ul>
          </div>
          <div className="iframe-wrapper">
            <LidarIframe
              zoid
              title={this.state.scene.title}
              frames={this.state.scene.frames}
              annotations={this.state.scene.annotations}
              showImages={this.state.scene.showImages}
              frame={this.state.scene.frame}
              bgColor={bgColor}
            />
          </div>
          <div className="select-grid">
            <div className="select-wrapper">
              <select onChange={this.updateSelect} value={this.state.sceneActive}>
                {this.props.scenes.map((scene: any, i: any) => (
                  <option key={scene.title} value={i}>
                    {scene.title}
                  </option>
                ))}
              </select>
              <div>
                <CTA
                  cta={{
                    text: 'Select Scene',
                    href: '/',
                    colors: {
                      bg: 'bg-black',
                      text: 'text-white'
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <style jsx>{`
          .lidar {
            background: transparent;
            display: grid;
            grid-template-columns: 1fr;
            grid-gap: 4rem;
            position: relative;
            z-index: 3;
            overflow: hidden;
          }
          @media (min-width: ${mq.lg}) {
            .lidar {
              grid-template-columns: 292px 1fr;
              grid-gap: calc(4rem / 2);
            }
          }
          .lidar .scenes-overflow {
            background: #f1f1f1;
            height: 538px;
            overflow: scroll;
            display: none;
          }
          @media (min-width: ${mq.lg}) {
            .lidar .scenes-overflow {
              display: block;
              height: 46.8vw;
            }
          }
          .lidar ul {
            margin: 0;
            padding: 0;
            list-style: none;
            overflow: hidden;
          }
          .lidar li {
            background-color: transparent;
            position: relative;
            height: 80px;
            padding: 0 calc(4rem / 2) 0;
            border-bottom: 1px solid #dcdcdc;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            transition: all 250ms ease-out;
          }
          .lidar li.active {
            background-color: ${viewerTheme.hover};
          }
          .lidar li.active:before {
            transform: translate3d(0, 0, 0);
            opacity: 1;
          }
          .lidar li:before {
            content: '';
            background-image: url('/static/img/website/open-datasets/scene-arrow.svg');
            background-repeat: no-repeat;
            background-size: calc(4rem / 2);
            background-position: center;
            width: 20px;
            height: 20px;
            border-radius: 100%;
            position: absolute;
            right: calc(4rem / 2);
            top: calc(50% - 4rem / 4);
            opacity: 0;
            transform: translate3d(-5px, 0, 0);
            transition: all 250ms ease-out;
          }
          .lidar li.soon {
            opacity: 0.5;
          }
          .lidar li.soon:before {
            content: initial;
          }
          .lidar li:not(.soon) {
            cursor: pointer;
          }
          .lidar li:not(.soon):hover {
            background-color: ${viewerTheme.hover};
          }
          .lidar .iframe-wrapper {
            width: 100%;
            height: 512px;
            position: relative;
            overflow: hidden;
            background: #000;
          }
          @media (min-width: ${mq.md}) {
            .lidar .iframe-wrapper {
              height: 538px;
            }
          }
          @media (min-width: ${mq.lg}) {
            .lidar .iframe-wrapper {
              height: 46.8vw;
            }
          }
          .lidar .select-grid {
            display: flex;
            align-items: center;
            justify-content: center;
          }
          @media (min-width: ${mq.lg}) {
            .lidar .select-grid {
              display: none;
            }
          }
          .lidar .select-wrapper {
            position: relative;
          }
          .lidar .select-wrapper select {
            height: 100%;
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            opacity: 0;
            z-index: 2;
            cursor: pointer;
          }
        `}</style>
      </div>
    );
  }
}

export default SceneViewer;
